import React from 'react';

interface ConversationSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * Search box for filtering conversations
 * Improved: Better focus states, clear button, responsive width
 */
const ConversationSearch: React.FC<ConversationSearchProps> = ({
  value,
  onChange,
  placeholder = 'Search'
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-row items-center px-3 py-2.5 gap-3 w-full bg-[#F8F9FA] border border-transparent rounded-xl transition-all duration-200 focus-within:bg-white focus-within:border-[#015FA6] focus-within:shadow-[0_0_0_3px_rgba(1,95,166,0.1)]">
        {/* Search icon */}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0 text-[#9CA3AF]"
        >
          <path
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 19L14.65 14.65"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        {/* Search input */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 font-manrope font-normal text-sm text-[#1A1A1A] bg-transparent border-none outline-none placeholder:text-[#9CA3AF]"
        />

        {/* Clear button */}
        {value && (
          <button
            onClick={() => onChange('')}
            className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-[#E5E7EB] hover:bg-[#D1D5DB] transition-colors"
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 2L2 8M2 2L8 8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default ConversationSearch;
